import React from 'react';

import type { UserExternalAccountApi } from '@/modules/user-external-accounts/types';

import { UserExternalAccountCard } from './UserExternalAccountCard';

interface UserExternalAccountListProps {
  externalAccounts: UserExternalAccountApi[];
  userId: string;
}

const UserExternalAccountList: React.FC<UserExternalAccountListProps> = ({
  externalAccounts,
  userId,
}) => {
  return (
    <div className="flex flex-col gap-4">
      {externalAccounts.map((account) => (
        <UserExternalAccountCard
          key={account.id}
          externalAccount={account}
          userId={userId}
        />
      ))}
    </div>
  );
};

export default UserExternalAccountList;
